/*
 * RETIRED 2026-07 — no render sites; see HANDOFF-FERMATA-CONFIGURATOR-STEP.md.
 *
 * Fermata cart-drawer upsell
 * --------------------------
 * Companion to snippets/fermata-cart-upsell.liquid. Vanilla JS, no deps.
 *
 * The cart drawer re-renders by replacing innerHTML, which never runs script
 * tags and destroys any per-element listeners. So everything here is
 * document-level event delegation installed once on first load; re-rendered
 * cards work without rebinding. Selected-swatch state lives in the card's DOM
 * (dataset + classes) and intentionally resets when the drawer re-renders.
 *
 * Reveal: the card renders `hidden` and only JS unhides it (so no-JS
 * browsers never see a dead Add button). There is deliberately NO dismiss
 * mechanism — the card simply lives while the gate (cable in cart, no
 * Fermata) holds. reveal() runs on load, on cart events, and via a debounced
 * body-wide MutationObserver (cards get swapped in by three different
 * systems at different times).
 *
 * Add-to-cart follows the theme convention (same as fermata-pack.js): POST
 * /cart/add.js, then dispatch arachne:cart:added + cart:refresh. The line
 * carries `_source: cart-upsell` so orders reveal whether the card converts.
 * After the add, the drawer re-renders with a Fermata in the cart and the
 * Liquid gate drops the card entirely.
 */
(function () {
  "use strict";

  // The snippet renders in both the drawer and the cart page, so /cart can
  // carry two copies of this script tag; only the first may bind delegation.
  if (window.__fermataUpsellInit) return;
  window.__fermataUpsellInit = true;

  // One in-flight add across ALL card copies (two copies can be visible on
  // /cart); a per-button guard would let a fast double-tap add two straps.
  var submitting = false;

  // A FAILED add must survive the header's refreshCart: custom-header.js
  // patches fetch, so even a failed /cart/add.js triggers a ~350ms-debounced
  // section refetch that rebuilds .mini-cart__inner — wiping the error
  // message and the shopper's colour pick about a second after they appear.
  // We remember the failure briefly and re-apply it to freshly built cards.
  var lastFail = null; // { id, msg, ts }
  var FAIL_TTL = 30000;

  // Last cart total we wrote into the recap panel (formatted string). The
  // configurator rewrites its Total to cable-only whenever it refills the
  // panel (e.g. an "Edit configuration" re-add) — if our confirmation row is
  // still there, the total must be re-lifted to the real cart total.
  var liftedTotal = null;
  var relifting = false;

  // Visually-hidden live region: the add removes every card copy, so the
  // announcement has to outlive the card for screen-reader users.
  var announcer = null;
  function announce(msg) {
    if (!msg) return;
    if (!announcer) {
      announcer = document.createElement("div");
      announcer.setAttribute("role", "status");
      announcer.setAttribute("aria-live", "polite");
      announcer.style.cssText = "position:absolute;width:1px;height:1px;overflow:hidden;clip:rect(0 0 0 0);white-space:nowrap;";
      document.body.appendChild(announcer);
    }
    announcer.textContent = "";
    window.setTimeout(function () { announcer.textContent = msg; }, 60);
  }

  // ---------------------------------------------------------------- match ---
  // The buyer just chose paracord colours in the configurator; those land in the
  // cart as line-item properties (Color 1, Color Left 2, ...). Asking them to
  // pick a leather colour cold, with the Add button refusing until they do, is a
  // second taste decision at exactly the wrong moment. So: read the cart, map
  // the cable's dominant colour onto a Fermata colour, pre-select it, and say so.
  // The swatches stay, so disagreeing costs one tap.
  var cartColour = null;      // {name: 'Black', leather: 'Onyx'} or null
  var cartColourDone = false;

  function normaliseColour(v) {
    // Values look like "1 Black" or "8 Wine" — strip the swatch number.
    return String(v || "").replace(/^\s*\d+\s*/, "").trim();
  }

  function dominantCableColour(cart) {
    var counts = {};
    var items = (cart && cart.items) || [];
    for (var i = 0; i < items.length; i++) {
      var props = items[i].properties || {};
      for (var k in props) {
        if (!Object.prototype.hasOwnProperty.call(props, k)) continue;
        if (!/^color/i.test(k)) continue;
        var name = normaliseColour(props[k]);
        if (!name) continue;
        counts[name] = (counts[name] || 0) + 1;
      }
    }
    var best = null, bestN = 0, distinct = 0;
    for (var c in counts) {
      distinct++;
      if (counts[c] > bestN) { best = c; bestN = counts[c]; }
    }
    // Two thirds of real cables are a colour MIX, so the suggestion matches the
    // dominant colour rather than "the cable". The copy has to say which.
    return best ? { name: best, single: distinct === 1 } : null;
  }

  function leatherFor(card, colourName) {
    if (!colourName) return null;
    var raw = card.getAttribute("data-fermata-colour-map");
    if (!raw) return null;
    var map;
    try { map = JSON.parse(raw); } catch (e) { return null; }
    var low = colourName.toLowerCase();
    if (map[low]) return map[low];
    for (var key in map) {                       // substring fallback
      if (low.indexOf(key) !== -1) return map[key];
    }
    return null;
  }

  function applyMatch(cards) {
    if (!cartColour) return;
    for (var i = 0; i < cards.length; i++) {
      var card = cards[i];
      // Never override a real choice, and never fight a remembered failure.
      if (card.dataset.selectedVariant) continue;
      var leather = cartColour.leather;
      var swatch = card.querySelector('[data-fermata-colour-name="' + leather + '"]');
      if (!swatch || swatch.classList.contains("is-disabled")) {
        var fb = card.getAttribute("data-fermata-fallback");
        swatch = fb ? card.querySelector('[data-fermata-colour-name="' + fb + '"]') : null;
        leather = fb;
      }
      if (!swatch || swatch.classList.contains("is-disabled")) continue;
      applySelection(card, swatch);
      var matchEl = card.querySelector("[data-fermata-upsell-match]");
      if (matchEl && cartColour.name) {
        matchEl.textContent = cartColour.single
          ? "Picked to match your " + cartColour.name + " cable"
          : "Goes with the " + cartColour.name + " in your cable";
      }
      var addBtn = card.querySelector("[data-fermata-upsell-add]");
      if (addBtn && !addBtn.classList.contains("is-loading")) {
        addBtn.textContent = "Add " + leather;
      }
    }
  }

  function ensureCartColour(cards) {
    if (cartColourDone) { applyMatch(cards); return; }
    cartColourDone = true;
    fetch("/cart.js", { headers: { "Accept": "application/json" } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var dom = dominantCableColour(cart);
        if (!dom) return;
        var probe = document.querySelector("[data-fermata-upsell]");
        var leather = probe ? leatherFor(probe, dom.name) : null;
        if (!leather && probe) leather = probe.getAttribute("data-fermata-fallback");
        if (!leather) return;
        cartColour = { name: dom.name, leather: leather, single: dom.single };
        applyMatch(document.querySelectorAll("[data-fermata-upsell]"));
      })
      .catch(function () { /* silent: card behaves exactly as before */ });
  }

  // Cards render `hidden` and only JS unhides them, so a browser without JS
  // never shows a card whose Add button couldn't work.
  function reveal() {
    syncPanelCopies();
    var cards = document.querySelectorAll("[data-fermata-upsell]");
    for (var i = 0; i < cards.length; i++) {
      cards[i].hidden = false;
    }
    restoreFailState(cards);
    ensureCartColour(cards);
    refreshLiftedTotals();
  }

  // Re-apply a recent failed add's colour pick + error message to cards that
  // were rebuilt from the server (which arrive blank). Idempotent.
  function restoreFailState(cards) {
    if (!lastFail) return;
    if (Date.now() - lastFail.ts > FAIL_TTL) { lastFail = null; return; }
    for (var i = 0; i < cards.length; i++) {
      var card = cards[i];
      if (card.dataset.selectedVariant === lastFail.id) continue;
      var swatch = card.querySelector('[data-fermata-upsell-swatch="' + lastFail.id + '"]');
      if (!swatch || swatch.classList.contains("is-disabled")) continue;
      applySelection(card, swatch);
      setStatus(card, lastFail.msg, true);
    }
  }

  function refreshLiftedTotals() {
    if (relifting || !liftedTotal) return;
    var feet = document.querySelectorAll(".acfg__drawer-foot");
    for (var f = 0; f < feet.length; f++) {
      var confirm = feet[f].querySelector("[data-fermata-upsell-confirm]");
      var totalEl = feet[f].querySelector(".acfg__drawer-total");
      if (!confirm || !totalEl) continue;
      if (totalEl.textContent === liftedTotal) continue;
      // Panel was refilled with a cable-only total while the strap is still
      // in the cart: fetch the truth once and re-lift. Converges — after the
      // write, textContent matches liftedTotal, so no further fetches.
      relifting = true;
      fetch("/cart.js").then(function (r) { return r.json(); }).then(function (cart) {
        liftedTotal = formatMoney(cart.total_price);
        var totals = document.querySelectorAll(".acfg__drawer-foot .acfg__drawer-total");
        for (var t = 0; t < totals.length; t++) totals[t].textContent = liftedTotal;
      }).catch(function () {}).then(function () { relifting = false; });
      return;
    }
  }

  // The cable configurator's "Added to cart" recap panel (.acfg__drawer-panel)
  // is what buyers actually see after adding a cable — the theme cart drawer
  // never opens there, and the next button they press is its Checkout. Keep a
  // clone of the card at the top of that panel's footer, refreshed from the
  // server-rendered source card on every pass so the gate stays truthful
  // (clone removed when the source disappears, e.g. once a Fermata is added).
  function syncPanelCopies() {
    var feet = document.querySelectorAll(".acfg__drawer-foot");
    if (!feet.length) return;
    var source = null;
    var cards = document.querySelectorAll("[data-fermata-upsell]");
    for (var i = 0; i < cards.length; i++) {
      if (!cards[i].closest(".acfg__drawer-foot")) { source = cards[i]; break; }
    }
    for (var f = 0; f < feet.length; f++) {
      // A live source card means no Fermata is in the cart anymore, so any
      // old "added" confirmation row is stale — drop it (and stop policing
      // the panel total).
      var confirm = feet[f].querySelector("[data-fermata-upsell-confirm]");
      if (confirm && source) { confirm.remove(); liftedTotal = null; }
      var existing = feet[f].querySelector("[data-fermata-upsell]");
      // Idempotent on purpose: the observer below watches the whole body, so
      // unconditional remove+reclone here would re-trigger it forever.
      if (existing && !source) { existing.remove(); continue; }
      if (!existing && source) {
        var copy = source.cloneNode(true);
        copy.classList.remove("fermata-upsell--row");
        // Never clone transient state: a source mid-error or mid-submit must
        // not seed the panel with a stale spinner or error message.
        var st = copy.querySelector("[data-fermata-upsell-status]");
        if (st) { st.textContent = ""; st.classList.remove("is-error"); }
        var ab = copy.querySelector("[data-fermata-upsell-add]");
        if (ab) ab.classList.remove("is-loading");
        feet[f].insertBefore(copy, feet[f].firstChild);
      }
    }
  }

  function formatMoney(cents) {
    try {
      var cur = (window.Shopify && Shopify.currency && Shopify.currency.active) || "EUR";
      return new Intl.NumberFormat(document.documentElement.lang || undefined, { style: "currency", currency: cur }).format(cents / 100);
    } catch (e) { return (cents / 100).toFixed(2); }
  }

  // The configurator's recap panel renders its own lines + Total and knows
  // nothing about a strap added from the upsell card — the card vanishing
  // with no trace and a stale Total reads as a bug (it did to Albert). Leave
  // a confirmation row in the card's slot and lift the panel Total to the
  // cart total, which is what its Checkout button charges anyway.
  function confirmInPanels(added, colourName) {
    var feet = document.querySelectorAll(".acfg__drawer-foot");
    if (!feet.length) return;
    var item = added && added.items && added.items[0];
    var cents = item ? (item.final_line_price != null ? item.final_line_price : item.price) : null;
    var label = "Fermata" + (colourName ? " · " + colourName : "") + (cents != null ? " — " + formatMoney(cents) : "");
    for (var f = 0; f < feet.length; f++) {
      if (feet[f].querySelector("[data-fermata-upsell-confirm]")) continue;
      var row = document.createElement("div");
      row.className = "fermata-upsell-confirm";
      row.setAttribute("data-fermata-upsell-confirm", "");
      var tick = document.createElement("span");
      tick.className = "fermata-upsell-confirm__tick";
      tick.textContent = "✓";
      row.appendChild(tick);
      row.appendChild(document.createTextNode(" " + label));
      feet[f].insertBefore(row, feet[f].firstChild);
    }
    fetch("/cart.js").then(function (r) { return r.json(); }).then(function (cart) {
      liftedTotal = formatMoney(cart.total_price);
      var totals = document.querySelectorAll(".acfg__drawer-foot .acfg__drawer-total");
      for (var t = 0; t < totals.length; t++) totals[t].textContent = liftedTotal;
    }).catch(function () { /* total stays as rendered */ });
  }

  function setStatus(card, msg, isError) {
    var el = card.querySelector("[data-fermata-upsell-status]");
    if (!el) return;
    el.textContent = msg || "";
    el.classList.toggle("is-error", !!isError);
  }

  function applySelection(card, btn) {
    card.dataset.selectedVariant = btn.getAttribute("data-fermata-upsell-swatch");
    var all = card.querySelectorAll("[data-fermata-upsell-swatch]");
    for (var i = 0; i < all.length; i++) {
      var sel = all[i] === btn;
      all[i].classList.toggle("is-selected", sel);
      all[i].setAttribute("aria-pressed", sel ? "true" : "false");
    }
    // Show the picked colour's photo in the card thumb.
    var img = card.querySelector("[data-fermata-upsell-img]");
    var src = btn.getAttribute("data-fermata-upsell-image");
    if (img && src) img.src = src;
    // And its name — seven dark circles are hard to tell apart on a dark UI.
    var nameEl = card.querySelector("[data-fermata-upsell-colour]");
    if (nameEl) nameEl.textContent = btn.getAttribute("aria-label") || "";
  }

  function onSwatch(btn) {
    if (btn.classList.contains("is-disabled")) return;
    var card = btn.closest("[data-fermata-upsell]");
    if (!card) return;
    lastFail = null; // a fresh pick supersedes any remembered failure
    applySelection(card, btn);
    setStatus(card, "", false);
    // A deliberate choice supersedes the cable-match suggestion: drop the
    // "picked to match" line and put the generic label back.
    var matchEl = card.querySelector("[data-fermata-upsell-match]");
    if (matchEl) matchEl.textContent = "";
    var addBtn = card.querySelector("[data-fermata-upsell-add]");
    if (addBtn && !addBtn.classList.contains("is-loading")) {
      addBtn.textContent = addBtn.getAttribute("data-add-text") || "Add";
    }
  }

  // Cart-page regions that must re-render after an add. cart-page-groups.js
  // never refetches on cart:refresh (only the drawer's script does), so we ask
  // /cart/add.js for the re-rendered sections and patch them in place; the
  // groups script's own MutationObserver then re-runs its enhancement.
  function cartPageSections() {
    var targets = [];
    var els = [document.querySelector("cart-items"), document.querySelector(".cart__footer")];
    for (var i = 0; i < els.length; i++) {
      if (!els[i]) continue;
      var wrap = els[i].closest(".shopify-section");
      if (wrap && wrap.id) targets.push({ id: wrap.id.replace("shopify-section-", ""), wrap: wrap });
    }
    return targets;
  }

  function applyCartPageSections(targets, sections) {
    if (!sections) return;
    for (var i = 0; i < targets.length; i++) {
      var html = sections[targets[i].id];
      if (!html) continue;
      try {
        var doc = new DOMParser().parseFromString(html, "text/html");
        var dst = targets[i].wrap.querySelector(".js-contents");
        var src = doc.querySelector(".js-contents");
        if (dst && src) {
          dst.innerHTML = src.innerHTML;
        } else {
          var inner = doc.querySelector(".shopify-section") || doc.body;
          targets[i].wrap.innerHTML = inner.innerHTML;
        }
      } catch (e) { /* non-fatal: totals catch up on next navigation */ }
    }
  }

  function onAdd(btn) {
    var card = btn.closest("[data-fermata-upsell]");
    if (!card || submitting || btn.classList.contains("is-loading")) return;
    var variantId = parseInt(card.dataset.selectedVariant, 10);
    if (!variantId) {
      setStatus(card, btn.getAttribute("data-choose-text") || "Choose a colour", true);
      return;
    }
    submitting = true;
    btn.classList.add("is-loading");
    // Which surface sold it: the configurator's recap panel, the theme cart
    // drawer, or the cart page row. Keeps the "cart-upsell" prefix so orders
    // can still be grouped on the family as a whole.
    var surface = "cart";
    if (card.closest(".acfg__drawer-foot")) surface = "recap";
    else if (card.closest("[data-mini-cart]")) surface = "mini";
    else if (card.closest("cart-drawer")) surface = "drawer";
    var pageTargets = cartPageSections();
    var body = { items: [{ id: variantId, quantity: 1, properties: { _source: "cart-upsell:" + surface } }] };
    if (pageTargets.length) {
      body.sections = pageTargets.map(function (t) { return t.id; }).join(",");
      body.sections_url = window.location.pathname;
    }
    fetch("/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json", "Accept": "application/json" },
      body: JSON.stringify(body)
    }).then(function (res) {
      // .catch on the parse: a 502/timeout HTML body must surface the
      // friendly error, not a raw JSON parser exception.
      return res.json().catch(function () { return null; }).then(function (json) { return { ok: res.ok, body: json }; });
    }).then(function (r) {
      if (!r.ok) {
        throw new Error((r.body && (r.body.description || r.body.message)) || "Could not add to cart.");
      }
      // On the cart page: swap in the fresh item list + totals immediately.
      applyCartPageSections(pageTargets, r.body && r.body.sections);
      // Recap panel: visible proof of the add before the card disappears.
      var selSwatch = card.querySelector(".fermata-upsell__swatch.is-selected");
      confirmInPanels(r.body, selSwatch ? (selSwatch.getAttribute("aria-label") || "") : "");
      // The card is about to vanish on every surface — announce the success
      // somewhere that survives it.
      announce(btn.getAttribute("data-added-text") || "Added to cart");
      lastFail = null;
      // Job done for this render: drop every copy of the card now (drawer,
      // cart page, recap panel) rather than waiting for the next server
      // render, whose Liquid gate removes it.
      var copies = document.querySelectorAll("[data-fermata-upsell]");
      for (var c = 0; c < copies.length; c++) copies[c].remove();
      document.dispatchEvent(new CustomEvent("arachne:cart:added", { detail: { items: body } }));
      try { document.dispatchEvent(new CustomEvent("cart:refresh")); } catch (e) {}
    }).catch(function (err) {
      var msg = err.message || "Something went wrong. Please try again.";
      setStatus(card, msg, true);
      // Survive the header's imminent mini-cart rebuild (see lastFail note).
      lastFail = { id: String(variantId), msg: msg, ts: Date.now() };
    }).then(function () {
      submitting = false;
      btn.classList.remove("is-loading");
    });
  }

  // Capture phase, not bubble: the configurator's recap panel stops click
  // propagation at its root, which would starve a bubble-phase document
  // listener for the card copy living inside that panel.
  document.addEventListener("click", function (e) {
    var t = e.target;
    if (!t || !t.closest) return;
    var swatch = t.closest("[data-fermata-upsell-swatch]");
    if (swatch) { onSwatch(swatch); return; }
    var add = t.closest("[data-fermata-upsell-add]");
    if (add) { onAdd(add); }
  }, true);

  // Watch the whole body: cards get swapped in by at least three different
  // systems (cart-drawer-groups.js footer swaps, Dawn's cart-page .js-contents
  // re-render, and the configurator REBUILDING its recap panel from scratch),
  // and each of those replaces different nodes at different times. reveal()
  // is cheap and idempotent (only mutates when state actually changed), so a
  // debounced body observer converges instead of looping.
  // setTimeout, not requestAnimationFrame: rAF callbacks stall while the page
  // isn't painting (backgrounded tab), leaving a swapped-in card hidden.
  function watchCartRoots() {
    if (!window.MutationObserver) return;
    var scheduled = false;
    new MutationObserver(function () {
      if (scheduled) return;
      scheduled = true;
      window.setTimeout(function () { scheduled = false; reveal(); }, 80);
    }).observe(document.body, { childList: true, subtree: true });
    // childList-only on purpose: every event we care about (footer swaps,
    // .js-contents re-renders, panel rebuilds, mini-cart inner swaps) adds or
    // removes nodes. Watching class attributes only added wake-ups on
    // animation-heavy pages.
  }

  function init() {
    reveal();
    watchCartRoots();
    document.addEventListener("cart:refresh", reveal);
    document.addEventListener("arachne:cart:added", reveal);
    // The configurator builds its recap panel after this script runs; a late
    // pass seeds the panel copy on pages where the cart already has a cable.
    window.setTimeout(reveal, 1500);
    window.setTimeout(reveal, 4000);
    // bfcache: a back-button restore revives a snapshot whose gates may be
    // stale (strap added/removed on another page or tab). Nudging the
    // header's refreshCart re-renders the mini-cart with the true state.
    window.addEventListener("pageshow", function (e) {
      if (e && e.persisted) {
        try { document.dispatchEvent(new CustomEvent("cart:refresh")); } catch (err) {}
      }
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
